<template>
  <header class="header" :class="{ scrolled: isScrolled }">
    <div class="header-inner">
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/logo/logo.jpg" alt="로고" />
        </router-link>
      </div>

      <nav class="nav-pc">
        <ul class="nav-menu">
          <li 
            class="nav-item" 
            v-for="menu in menuList" 
            :key="menu.title"
            @mouseenter="openMegaMenu(menu.title)"
            @mouseleave="closeMegaMenu"
          >
            <router-link :to="menu.path" class="nav-title">
              {{ menu.title }}
            </router-link>
          </li>
        </ul>
      </nav>

      <div class="header-right">
        <div class="phone-box">
          <span class="phone-label">대표번호</span>
          <a href="tel:1600-9768">1600-9768</a>
        </div>
      </div>

      <button class="mobile-menu-btn" @click="toggleMobileMenu" :class="{ active: isMobileMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- 메가메뉴 -->
    <div 
      class="mega-menu" 
      :class="{ open: activeMegaMenu }"
      @mouseenter="keepMegaMenuOpen"
      @mouseleave="closeMegaMenu"
    >
      <div class="mega-menu-inner">
        <div 
          class="mega-column" 
          v-for="menu in menuList" 
          :key="menu.title"
          :class="{ active: activeMegaMenu === menu.title }"
          @mouseenter="activeMegaMenu = menu.title"
        >
          <h3 class="column-title">{{ menu.title }}</h3>
          <ul class="column-list">
            <li v-for="sub in menu.subMenu" :key="sub.name">
              <router-link :to="sub.path" @click="closeMegaMenu">
                {{ sub.name }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 모바일 메뉴 -->
    <div class="nav-mobile" :class="{ open: isMobileMenuOpen }">
      <div class="mobile-menu-inner">
        <ul class="mobile-menu">
          <li v-for="menu in menuList" :key="menu.title" class="mobile-menu-item">
            <button class="mobile-menu-title" @click="toggleSubMenu(menu.title)" :class="{ active: openSubMenu === menu.title }">
              {{ menu.title }}
              <span class="arrow"></span>
            </button>
            <ul class="mobile-sub-menu" :class="{ open: openSubMenu === menu.title }">
              <li v-for="sub in menu.subMenu" :key="sub.name">
                <router-link :to="sub.path" @click="closeMobileMenu">{{ sub.name }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
        <div class="mobile-phone">
          <a href="tel:1600-9768">
            <span>대표번호</span>
            1600-9768
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      isScrolled: false,
      activeMegaMenu: null,
      closeTimer: null,
      isMobileMenuOpen: false,
      openSubMenu: null,
      menuList: [
        {
          title: '사업안내',
          path: '/business',
          subMenu: [
            { name: '사업개요', path: '/business/overview' },
            { name: '브랜드소개', path: '/business/brand' },
            { name: '프리미엄', path: '/business/company' },
            { name: '오시는길', path: '/business/location' }
          ]
        },
        {
          title: '상품안내',
          path: '/unit',
          subMenu: [
            { name: '단지·동호수 배치도', path: '/unit/type' },
            { name: '커뮤니티', path: '/unit/community' }
          ]
        },
        {
          title: '입지안내',
          path: '/premium',
          subMenu: [
            { name: '입지환경', path: '/premium/location' },
          ]
        },
        {
          title: '공간안내',
          path: '/complex',
          subMenu: [
            { name: '평면안내', path: '/complex/design' },
          ]
        },
        {
          title: '홍보센터',
          path: '/support',
          subMenu: [
            { name: '관심고객등록', path: '/support' }
          ]
        }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.closeTimer) {
      clearTimeout(this.closeTimer)
    }
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    openMegaMenu(title) {
      // 닫기 타이머가 있으면 취소
      if (this.closeTimer) {
        clearTimeout(this.closeTimer)
        this.closeTimer = null
      }
      this.activeMegaMenu = title
    },
    closeMegaMenu() {
      // 딜레이를 주고 닫기 (그 사이에 메가메뉴로 이동하면 취소됨)
      this.closeTimer = setTimeout(() => {
        this.activeMegaMenu = null
      }, 150)
    },
    keepMegaMenuOpen() {
      // 메가메뉴 위에 마우스가 있으면 닫기 타이머 취소
      if (this.closeTimer) {
        clearTimeout(this.closeTimer)
        this.closeTimer = null
      }
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      if (!this.isMobileMenuOpen) {
        this.openSubMenu = null
      }
      // 바디 스크롤 제어
      document.body.style.overflow = this.isMobileMenuOpen ? 'hidden' : ''
    },
    toggleSubMenu(title) {
      this.openSubMenu = this.openSubMenu === title ? null : title
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      this.openSubMenu = null
      document.body.style.overflow = ''
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 1000;
  transition: all 0.3s;
}

.header.scrolled {
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
}

.header-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 로고 */
.logo {
  flex-shrink: 0;
}

.logo img {
  height: 75px;
}

/* PC 네비게이션 */
.nav-pc {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 8px;
}

.nav-item {
  position: relative;
}

.nav-title {
  display: block;
  padding: 28px 24px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
  letter-spacing: -0.3px;
}

.nav-title:hover {
  color: var(--main-color1);
}

/* 헤더 오른쪽 */
.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.phone-box {
  display: flex;
  align-items: center;
  gap: 10px;
}

.phone-label {
  font-size: 13px;
  color: #888;
  font-weight: 500;
}

.phone-box a {
  font-size: 22px;
  font-weight: 700;
  color: var(--main-color1);
  text-decoration: none;
  letter-spacing: -0.5px;
}

/* 메가메뉴 */
.mega-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  border-top: 1px solid #eee;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
}

/* 메가메뉴 위에 투명 연결 영역 */
.mega-menu::before {
  content: '';
  position: absolute;
  top: -20px;
  left: 0;
  width: 100%;
  height: 20px;
  background: transparent;
}

.mega-menu.open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.mega-menu-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px;
  display: flex;
  justify-content: center;
  gap: 60px;
}

.mega-column {
  min-width: 150px;
  opacity: 0.5;
  transition: opacity 0.3s;
}

.mega-column.active {
  opacity: 1;
}

.column-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--main-color1);
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid var(--main-color1);
}

.column-list {
  list-style: none;
}

.column-list li {
  margin-bottom: 12px;
}

.column-list li a {
  display: block;
  font-size: 14px;
  color: #555;
  text-decoration: none;
  transition: all 0.2s;
  padding: 6px 0;
}

.column-list li a:hover {
  color: var(--main-color1);
  padding-left: 8px;
}

/* 모바일 메뉴 버튼 */
.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  gap: 6px;
  padding: 0;
}

.mobile-menu-btn span {
  display: block;
  width: 24px;
  height: 2px;
  background: #333;
  border-radius: 2px;
  transition: all 0.3s;
}

.mobile-menu-btn.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 6px);
}

.mobile-menu-btn.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -6px);
}

/* 모바일 네비게이션 */
.nav-mobile {
  display: none;
  position: fixed;
  top: 80px;
  left: 0;
  width: 100%;
  height: calc(100vh - 80px);
  background: #fff;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  overflow-y: auto;
}

.nav-mobile.open {
  transform: translateX(0);
}

.mobile-menu-inner {
  padding: 30px 25px;
}

.mobile-menu {
  list-style: none;
}

.mobile-menu-item {
  border-bottom: 1px solid #f0f0f0;
}

.mobile-menu-title {
  width: 100%;
  padding: 20px 0;
  font-size: 17px;
  font-weight: 600;
  color: #333;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  letter-spacing: -0.3px;
}

.mobile-menu-title .arrow {
  width: 8px;
  height: 8px;
  border-right: 2px solid #aaa;
  border-bottom: 2px solid #aaa;
  transform: rotate(45deg);
  transition: transform 0.3s;
}

.mobile-menu-title.active {
  color: var(--main-color1);
}

.mobile-menu-title.active .arrow {
  transform: rotate(-135deg);
  border-color: var(--main-color1);
}

.mobile-sub-menu {
  list-style: none;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  background: #fafafa;
  margin: 0 -25px;
  padding: 0 25px;
}

.mobile-sub-menu.open {
  max-height: 500px;
}

.mobile-sub-menu li a {
  display: block;
  padding: 14px 20px;
  font-size: 15px;
  color: #666;
  text-decoration: none;
  transition: color 0.2s;
}

.mobile-sub-menu li a:hover,
.mobile-sub-menu li a:active {
  color: var(--main-color1);
}

.mobile-phone {
  margin-top: 40px;
  text-align: center;
}

.mobile-phone a {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  background: var(--main-color1);
  color: #fff;
  padding: 18px 50px;
  border-radius: 8px;
  font-size: 22px;
  font-weight: 700;
  text-decoration: none;
}

.mobile-phone a span {
  font-size: 12px;
  font-weight: 400;
  opacity: 0.8;
}

/* 반응형 */
@media (max-width: 1280px) {
  .header-inner {
    padding: 0 30px;
  }

  .nav-title {
    padding: 28px 18px;
    font-size: 15px;
  }

  .mega-menu-inner {
    gap: 40px;
  }
}

@media (max-width: 1024px) {
  .nav-pc,
  .header-right {
    display: none;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .nav-mobile {
    display: block;
  }

  .header-inner {
    height: 65px;
    padding: 0 20px;
  }

  .logo img {
    height: 36px;
  }

  .nav-mobile {
    top: 65px;
    height: calc(100vh - 65px);
  }
}
</style>